import { ReactNode } from "react";

import Box from "ds/components/Box";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import TooltipInfo from "ds/components/TooltipInfo";

type FlowsProjectsSectionHeaderProps = {
  children?: ReactNode;
};

const FlowsProjectsSectionHeader = ({ children }: FlowsProjectsSectionHeaderProps) => (
  <PageInfoHeaderWrapper>
    <Box align="center" gap="medium">
      <PageInfoHeaderTitle title="Projects" />
      <TooltipInfo widthMode="maxWidthSm">
        Projects are listed live from your linked Flows organization.
      </TooltipInfo>
    </Box>

    <Box align="center" gap="medium" shrink="0">
      {children}
    </Box>
  </PageInfoHeaderWrapper>
);

export default FlowsProjectsSectionHeader;
